import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>

        <h1 style={styles.mainTitle}>Maamaas Privacy Policy</h1>

        <p style={styles.updated}>Last Updated: 15-10-2025</p>

        <Section text={`Maamaas (“we”, “our”, “us”, or “Company”) is a platform operated and managed in affiliation with Envision Integrated Services Pvt Ltd. We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, process, and disclose your information when you access or use our mobile application, website, and related services (collectively referred to as the “Services”). By accessing or using Maamaas, you agree to the terms of this Privacy Policy and consent to the collection and use of your information as described herein.`} />

        <Section text={`This Privacy Policy applies to all users of the platform, including customers, restaurant or merchant partners, delivery or service partners, and visitors who access our Services.`} />

        <Title text="Information We Collect" />

        <Section text={`We collect personal information that you provide directly such as name, mobile number, email address, delivery address, login credentials, and preferences when you use our Services.`} />

        <Section text={`We collect transactional data including order details, purchase history, payment method, and billing information. Payment data is handled securely via third-party gateways.`} />

        <Section text={`We also collect location data including GPS and saved addresses to provide delivery services.`} />

        <Section text={`We automatically collect technical data such as device type, OS, IP address, usage behavior, and log data.`} />

        <Title text="How We Use Your Information" />

        <Section text={`We use your information to process orders, manage deliveries, improve services, personalize experience, provide customer support, and send notifications or updates.`} />

        <Section text={`We also use data to detect fraud, prevent abuse, ensure platform security, and comply with legal obligations.`} />

        <Title text="Sharing of Information" />

        <Section text={`We share information only when necessary with restaurants, delivery partners, payment providers, and trusted service providers under confidentiality agreements.`} />

        <Section text={`Your data may also be shared within Envision Integrated Services Pvt Ltd for operational, support, analytics, and compliance purposes.`} />

        <Section text={`We do NOT sell, rent, or trade your personal data.`} />

        <Title text="Data Retention" />

        <Section text={`We retain data as long as your account is active or required for legal, operational, and security purposes. Some data may remain after deletion for compliance and fraud prevention.`} />

        <Title text="Security" />

        <Section text={`We use encryption, secure servers, and restricted access systems to protect your data. However, no system is 100% secure.`} />

        <Title text="Your Rights" />

        <Section text={`You can access, update, or delete your data anytime. You may also opt out of marketing communications through your account settings.`} />

        <Title text="Cookies" />

        <Section text={`We use cookies to improve performance, personalize content, and analyze usage. You can disable cookies in browser settings.`} />

        <Title text="Third-Party Links" />

        <Section text={`We are not responsible for third-party websites linked through our platform. Please review their policies separately.`} />

        <Title text="Children Policy" />

        <Section text={`Maamaas is not intended for users under 18 years of age. We do not knowingly collect data from minors.`} />

        <Title text="Delivery & Partner Data" />

        <Section text={`We collect additional data from restaurant and delivery partners including business details, bank information, identity verification, and performance data for operational purposes.`} />

        <Section text={`Delivery partners may have real-time location tracking enabled during active deliveries.`} />

        <Title text="Policy Updates" />

        <Section text={`We may update this Privacy Policy anytime. Continued use of our Services means acceptance of updated terms.`} />

        <Title text="Legal Disclaimer" />

        <Section text={`To the maximum extent permitted by law, Maamaas and Envision Integrated Services Pvt Ltd are not liable for indirect or incidental damages arising from unauthorized access to your data.`} />

        <Title text="Contact Us" />

        <Section text={`Email: your email address\nPhone: your contact number`} />

        <Section text={`By using Maamaas, you confirm that you have read and agreed to this Privacy Policy.`} />

      </div>
    </div>
  );
}

/* ---------------- Components ---------------- */

function Title({ text }) {
  return <h2 style={styles.title}>{text}</h2>;
}

function Section({ text }) {
  return <p style={styles.text}>{text}</p>;
}

/* ---------------- Styles ---------------- */

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "30px 15px",
    background: "linear-gradient(135deg, #f3f4f6, #eef2f7)",
    fontFamily: "Arial, sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "1450px",
    background: "#ffffff",
    borderRadius: "18px",
    padding: "40px",
    boxShadow: "0 12px 35px rgba(0,0,0,0.08)",
  },

  mainTitle: {
    fontSize: "30px",
    fontWeight: "800",
    color: "#111",
    marginBottom: "5px",
  },

  updated: {
    fontSize: "13px",
    color: "#777",
    marginBottom: "25px",
  },

  title: {
    fontSize: "18px",
    fontWeight: "700",
    marginTop: "25px",
    marginBottom: "10px",
    color: "#f97316", // ORANGE THEME
    borderLeft: "4px solid #f97316",
    paddingLeft: "10px",
  },

  text: {
    fontSize: "14px",
    color: "#444",
    lineHeight: "1.7",
    marginBottom: "12px",
    whiteSpace: "pre-line",
  },
};